if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', (e) => {
              console.log('👆 Thumbnail clicked:', mediaToSwitch.dataset.target);
              this.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        console.log('🔍 setActiveMedia called with:', { mediaId, prepend });

        // Tenta match exato primeiro
        let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        // Se não achou, tenta match pelo sufixo numérico
        if (!activeMedia) {
          const numericId = mediaId.split('-').pop();
          activeMedia = this.elements.viewer.querySelector(`[data-media-id$="-${numericId}"]`);
          console.log('🔎 Trying suffix match with:', numericId);
        }

        if (!activeMedia) {
          console.warn('❌ Active media not found for:', mediaId);
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        console.log('✅ Added is-active to:', activeMedia.dataset.mediaId);

        if (prepend) {
          const wasMoved = activeMedia.parentElement.firstChild !== activeMedia;

          if (wasMoved) {
            // Remove is-active de todos antes de mover
            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
              element.classList.remove('is-active');
            });

            activeMedia.parentElement.prepend(activeMedia);
            console.log('📦 Prepended activeMedia to first position');

            // Re-adiciona is-active após mover
            activeMedia.classList.add('is-active');
            console.log('✅ Re-added is-active after prepend');
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              const thumbnailWasMoved = activeThumbnail.parentElement.firstChild !== activeThumbnail;
              if (thumbnailWasMoved) {
                activeThumbnail.parentElement.prepend(activeThumbnail);
                console.log('🖼️ Prepended thumbnail to first position');
              }
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
            console.log('🔄 Reset slider pages');
          }

          // Force reflow para garantir que o DOM seja atualizado
          void activeMedia.offsetHeight;

          // Force display block no elemento ativo
          activeMedia.style.display = '';
          console.log('👁️ Forced display on active media');
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        // Verifica se é layout vertical (desktop) ou horizontal (mobile)
        const isVerticalLayout = window.innerWidth >= 990 && this.elements.thumbnails.classList.contains('thumbnail-slider--vertical');

        if (isVerticalLayout) {
          // Scroll vertical para desktop usando scrollIntoView
          thumbnail.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        } else {
          // Scroll horizontal para mobile/tablet
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
